import { parseEntryUrl, parsePageUrl } from "./origin.js";
import { isPublicSuffix } from "./psl.js";
const IPV4 = /^\d{1,3}(\.\d{1,3}){3}$/u;
const LOOPBACK_V4 = /^127(\.\d{1,3}){3}$/u;
function isIpOrLocal(hostname) {
    return IPV4.test(hostname) || hostname.startsWith("[") || hostname === "localhost" || !hostname.includes(".");
}
/** This machine: localhost, *.localhost, 127.0.0.0/8 and [::1]. Plain http there is a dev setup, not a risk. */
export function isLoopbackHost(hostname) {
    const host = hostname.toLowerCase().replace(/\.$/u, "");
    return host === "localhost" || host.endsWith(".localhost") || LOOPBACK_V4.test(host) || host === "[::1]";
}
/** Drops a leading "www." unless what is left is a public suffix ("www.github.io" is a site of its own). */
function stripWww(hostname) {
    if (!hostname.startsWith("www.")) {
        return hostname;
    }
    const rest = hostname.slice(4);
    return isPublicSuffix(rest) ? hostname : rest;
}
/** Host shown in the UI and used for grouping. */
export function displayHost(raw) {
    const parsed = parseEntryUrl(raw);
    return parsed === undefined ? undefined : stripWww(parsed.hostname);
}
/**
 * Matches an entry URL against a page URL.
 * - exact: same host (ignoring a leading "www.").
 * - subdomain: the page is a subdomain of the stored host (login.example.com for example.com).
 *   Never for a stored public suffix: an entry for "github.io" or "co.uk" matches only itself,
 *   not every site registered under it.
 * IPs, localhost and single-label hosts must match exactly, including the port.
 * A stored port always has to match.
 */
export function matchEntry(entryUrl, pageUrl) {
    const entry = parseEntryUrl(entryUrl);
    const page = parsePageUrl(pageUrl);
    if (entry === undefined || page === undefined) {
        return undefined;
    }
    if (entry.port !== "" && entry.port !== page.port) {
        return undefined;
    }
    const downgrade = entry.protocol === "https:" && page.protocol === "http:";
    const insecure = page.protocol === "http:" && !isLoopbackHost(page.hostname);
    if (isIpOrLocal(entry.hostname) || isIpOrLocal(page.hostname)) {
        if (entry.hostname !== page.hostname || entry.port !== page.port) {
            return undefined;
        }
        return { kind: "exact", downgrade, insecure };
    }
    const stored = stripWww(entry.hostname);
    const host = stripWww(page.hostname);
    if (stored === host) {
        return { kind: "exact", downgrade, insecure };
    }
    if (host.endsWith(`.${stored}`) && !isPublicSuffix(stored)) {
        return { kind: "subdomain", downgrade, insecure };
    }
    return undefined;
}
//# sourceMappingURL=match.js.map